/**
 * @generated SignedSource<<84ffca27fbfe7c65cbcf62a794426f5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ReactionsContentFragment_content$data = {
  readonly contentReactionsSummary: {
    readonly ari: string;
    readonly containerAri: string;
    readonly reactionsCount: number;
    readonly reactionsSummaryForEmoji: ReadonlyArray<{
      readonly count: number;
      readonly emojiId: string;
      readonly id: string;
      readonly reacted: boolean;
    } | null>;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "ReactionsContentFragment_content";
};
export type ReactionsContentFragment_content$key = {
  readonly " $data"?: ReactionsContentFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ReactionsContentFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "contentReactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            },
            (v0/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "8f56d4c4019bf4c3d755d097e2930c4e";

export default node;
